/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react'
import { Image, Modal, Space } from "antd";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import customStyles from "../../../../../assets/styles/customStyles";
import { Button, TextField, Box, FormControlLabel, Switch, TableCell, TableRow, Typography } from "@mui/material";
import { capitalizeFirstLetter } from "../../../../../helpers/utilities";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { teamHead } from "../../../../../config/constant";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import crudActions from "../../../../CRUD/redux/actions";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { emptyValidation, customPhoneValidation, customAlaphabetValidation, customEmailValidation } from "../../../../../helpers/validation";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { checkCRUDPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';

export const TeamTable = (props) => {
    const [visible, setVisible] = useState(false);
    const [teamId, setTeamId] = useState(false);
    const [fullName, setFullName] = useState(false);
    const [mobileNo, setMobileNo] = useState(false);
    const [emailId, setEmailId] = useState(false);
    const [roles, setRoles] = useState(false);
    const [roleName, setRoleName] = useState(false);
    const [view, setView] = useState(false);
    const { roleDetails, details, onRequestSort, sortOrder, sortBy, loadTasks, search, customObject, roleManagement, loadMore, loadMoreContent, loadMoreTask, roleId, userId } = props;

    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const [team, setTeam] = useState(false);
    const [teamValue, setTeamValue] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [isTeamModalVisible, setIsTeamModalVisible] = useState(false);
    const timeoutRef = useRef(null);
    const prevSearch = usePrevious(search);
    let [dataState, setDataState] = useState([]);

    const handleClose = () => {
        setVisible(false);
        emptyState();
    };

    const handleOk = () => {
        setIsTeamModalVisible(false);
    };
    const handleCancel = () => {
        setIsTeamModalVisible(false);
    };

    const onEdit = (data, view = false) => {
        setVisible(true);
        setTeamId(data.id);
        setFullName(data.name);
        setMobileNo(data.mobile);
        setEmailId(data.email);
        setRoles(data.roleId);
        setRoleName(data?.role?.name);
        setView(view);
    }

    const [errorName, setErrorName] = useState(false);
    const [errorMobile, setErrorMobile] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorRole, setErrorRole] = useState(false);
    const [errorCommon, setErrorCommon] = useState(false);

    const onDelete = (data) => {
        setDeleteModal(true);
        setTeam(data.name);
        setTeamId(data.id);
    }

    const emptyState = () => {
        setErrorName(false);
        setErrorMobile(false);
        setErrorEmail(false);
        setErrorRole(false);
        setErrorCommon(false);
    }

    const dispatch = useDispatch();
    const editTeam = (e) => {
        e.preventDefault();
        let emptyName = customAlaphabetValidation('Full Name', fullName);
        let emptyMobile = customPhoneValidation('Mobile', mobileNo, 10);
        let emptyEmail = customEmailValidation('Email', emailId);
        let emptyRole = emptyValidation('Role', roles);
        emptyState();
        if (emptyName.isValid && emptyMobile.isValid && emptyEmail.isValid && emptyRole.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                id: teamId,
                url: 'team/user',
                title: "Team member",
                details: {
                    name: fullName,
                    email: emailId,
                    mobile: mobileNo,
                    roleId: roles
                }
            });
        } else {
            if (emptyName.errors !== '') {
                setErrorName(emptyName.errors);
            } if (emptyMobile.errors !== '') {
                setErrorMobile(emptyMobile.errors);
            } if (emptyEmail.errors !== '') {
                setErrorEmail(emptyEmail.errors);
            } if (emptyRole.errors !== '') {
                setErrorRole(emptyRole.errors);
            }
        }
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            setVisible(false);
            toast.dismiss();
            toast('Team updated successfully');
            setIsTeamModalVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            let error = message.split("|");
            if (error[0] === 'mobile') {
                setErrorMobile(error[1]);
            } else if (error[0] === 'email') {
                setErrorEmail(error[1]);
            } else {
                toast.dismiss();
                toast.error(message);
            }

        }
    }, [editDetails, editError]);

    useEffect(() => {
        let v = details && details?.length > 0 && details?.map((item) => {
            return {
                ...item,
                checked: item.status === 'ACTIVE' ? true : false
            }
        });
        setDataState(v);
    }, [details]);



    const handleActiveDeactive = (data, value) => {
        setIsTeamModalVisible(true);
        setTeamValue(value);
        setTeam(data.name);
        setTeamId(data.id);
    };

    const handleTeamStatus = () => {
        const updatedDataArray = dataState.map((item) => {
            if (item.id === teamId) {
                return {
                    ...item,
                    checked: teamValue
                }
            }
            return item;
        });
        setDataState(updatedDataArray);
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: 'team/user',
            title: "Team member",
            id: teamId,
            details: {
                status: teamValue ? 'ACTIVE' : 'INACTIVE'
            }
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                let v = details && details?.length > 0 && details?.map((item) => {
                    return {
                        ...item,
                        checked: item.status === 'ACTIVE' ? true : false
                    }
                });
                setDataState(v);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    let v = details && details?.length > 0 && details?.filter(item =>
                        item?.name?.toLowerCase().includes(search.toLowerCase()) ||
                        item?.email?.toLowerCase().includes(search.toLowerCase()) ||
                        item?.mobile?.toLowerCase().includes(search.toLowerCase())
                    )?.map((item) => {
                        return {
                            ...item,
                            checked: item.status === 'ACTIVE' ? true : false
                        }
                    });
                    setDataState(v);

                }, 500);
            }
        }
    }, [search]);

    const classes = customStyles()
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={teamHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                width={true}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={7}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && dataState?.length > 0 ? dataState.map((data, i) => (
                                            <TableRow
                                                key={i}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell key={data.name}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Team Management', 'view', 'Admin') ?
                                                            <NavLink to={"#"} id={idNamingConversion('View_' + data.id, 'teamManagement', 'Link')} className={clsx(classes.color, classes.bold)} onClick={() => onEdit(data, true)}>{data.name}</NavLink> : data.name
                                                    }
                                                </TableCell>
                                                <TableCell>{data.mobile}</TableCell>
                                                <TableCell>{data.email}</TableCell>
                                                <TableCell>{data.role ? data.role.name : '---'}</TableCell>
                                                <TableCell>{data.status === 'PENDING' ? <span className={classes.colorRed}>{'Pending Authentication'}</span> : capitalizeFirstLetter(data.status)}</TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Team Management', 'view', 'Admin') &&
                                                            <NavLink to={"#"}
                                                                id={idNamingConversion('View_' + data.id, 'teamManagement', 'Icon')}
                                                                onClick={() => onEdit(data, true)}>
                                                                <Image
                                                                    src={ViewIcon}
                                                                    preview={false}
                                                                    className={classes.cursor}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && userId !== data.id && roleId !== 1 && checkCRUDPermission('Team Management', 'edit', 'Admin') &&
                                                            <NavLink
                                                                id={idNamingConversion('Edit_' + data.id, 'teamManagement', 'Icon')}
                                                                to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                    className={classes.cursor}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && userId !== data.id && roleId !== 1 && checkCRUDPermission('Team Management', 'deletable', 'Admin') &&
                                                            <NavLink to={"#"}
                                                                id={idNamingConversion('Delete_' + data.id, 'teamManagement', 'Icon')}
                                                                onClick={() => onDelete(data)}>
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && userId !== data.id && roleId !== 1 && checkComponentPermission('Team Management', 'Action', 'Status Edit') &&
                                                            <FormControlLabel
                                                                id={idNamingConversion('Status_' + data.id, 'teamManagement', 'Icon')}
                                                                className={clsx(classes.toggleClassLabel, classes.rMarginRight, classes.marginLeft0)}
                                                                control={
                                                                    <Switch size="small"
                                                                        className={clsx(classes.marginLeft10, classes.customSwitch)}
                                                                        onChange={(e) => handleActiveDeactive(data, e.target.checked)}
                                                                        checked={data.checked} />
                                                                }
                                                                label=""
                                                            />
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                <TableCell className={classes.textAlignCenter} colSpan={7}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>No results found</p>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={`${view ? 'View' : 'Edit'} Team`}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => editTeam(e)}
                    >
                        <div className={classes.customFormFlex}>
                            {
                                errorCommon && <CustomAlert error={errorCommon} customClass={clsx(classes.uploadError, classes.margin10t)} />
                            }
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Full Name</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{fullName || '---'}</Typography>
                                </> : <TextField autoComplete='one-time-code'
                                    label={["Full Name ", <span key={'Full Name'} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorName && true}
                                    helperText={errorName}
                                    id={idNamingConversion('Full Name', 'teamManagement', 'TextField')}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)}
                                />
                            }
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Mobile Number</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{mobileNo || '---'}</Typography>
                                </> : <TextField autoComplete='one-time-code'
                                    label={["Mobile Number ", <span key={'Mobile Number'} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorMobile && true}
                                    helperText={errorMobile}
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    id={idNamingConversion('Mobile Number', 'teamManagement', 'TextField')}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    value={mobileNo}
                                    onChange={(e) => setMobileNo(e.target.value)}
                                />
                            }
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Email Id</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{emailId || '---'}</Typography>
                                </> : <TextField autoComplete='one-time-code'
                                    label={["Email Id ", <span key={'Email Id'} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorEmail && true}
                                    helperText={errorEmail}
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    id={idNamingConversion('Email Id', 'teamManagement', 'TextField')}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    value={emailId}
                                    onChange={(e) => setEmailId(e.target.value)}
                                />
                            }
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Role</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{roleName || '---'}</Typography>
                                </> : <AutoCompleteComponent
                                    name={["Role ", <span key={'Role'} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Role Name' }]}
                                    details={roleDetails}
                                    parentValue={customObject(roleDetails, roles)}
                                    onChange={(data) => setRoles(data.id)}
                                    position={'bottom'}
                                    id={idNamingConversion('Role', 'teamManagement', 'DropDown')}
                                    customClasses={classes.margin20t}
                                    parentError={errorRole}
                                />
                            }
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            {
                                userId !== teamId && <>
                                    {
                                        view ? <NavLink to="#" id={idNamingConversion('Edit', 'teamManagement', 'Link')}
                                            className={clsx(classes.modalBtn, { [classes.loading]: editLoader })} onClick={() => setView(false)}>Edit
                                        </NavLink> : <Button
                                            key="yes"
                                            type='submit'
                                            color='primary'
                                            variant="contained"
                                            id={idNamingConversion('Update', 'teamManagement', 'Button')}
                                            className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}>Update</Button>
                                    }
                                </>
                            }
                        </div>
                    </Box>
                }
            />
            <Modal
                title={'Status Confirmation'}
                open={isTeamModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                className={clsx(classes.deletePopup)}
                // closeIcon={<CloseIcon />}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        id={idNamingConversion('Yes', 'teamManagement', 'Button')}
                        className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                        onClick={() => handleTeamStatus()}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        id={idNamingConversion('No', 'teamManagement', 'Button')}
                        className={clsx(classes.AddMoreBtn)}
                        onClick={() => handleCancel()}>
                        No
                    </Button>,
                ]}
            >
                <p>Are you sure you want to <span className={classes.deleteRed}> {teamValue ? 'ACTIVE' : 'INACTIVE'} </span> {team}</p>
            </Modal>
            <DeleteModal onClose={(v) => handleDeleteModal(v)}
                id={teamId} loadTasks={() => loadTasks()}
                name={team} url={'team/user'} title={'Team'}
                visible={deleteModal} />
        </>
    );
}